import './index.css';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useBreakpoint } from '@hh.ru/magritte-ui-breakpoint';
import { NavigationBarComponent } from './NavigationBarComponent.js';
import 'react';
import 'classnames';
import '@hh.ru/magritte-common-func-utils';
import '@hh.ru/magritte-internal-custom-scroll';
import '@hh.ru/magritte-ui-divider';
import '@hh.ru/magritte-ui-layer';
import './NavigationBarItem-BQ6pdgfa.js';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-link';
import './NavigationBarItems.js';
import '@hh.ru/magritte-ui-icon/icon';
import './types.js';
import '@hh.ru/magritte-ui-progress-bar';

const NavigationBar = ({ children, ...props }) => {
    const { isMobile } = useBreakpoint();
    if (!isMobile) {
        return jsx(Fragment, { children: children });
    }
    return (jsxs(Fragment, { children: [jsx(NavigationBarComponent, { ...props, inLayer: true }), children] }));
};
NavigationBar.isNavigationBar = true;

export { NavigationBar };
//# sourceMappingURL=NavigationBar.js.map
